const ROOT = '/area-management'

const areaManagementPaths = {
  root: ROOT,
  area: `${ROOT}/area`,
  AddArea: `${ROOT}/add-area`,
};

export default areaManagementPaths;